import 'select2';
import $ from 'jquery';
import links from './links';
import multiChoiceSelects from './multi-choice-selects';

// Make jQuery and select2 globally available
window.$ = window.jQuery = $;

export default () => {
  links();
  multiChoiceSelects();
}
